/**
 * Módulo para el menú móvil off-canvas con navegación por pantallas
 * Controla la funcionalidad del botón de menú en dispositivos móviles
 * Este módulo se auto-inicializa cuando el DOM está listo
 */

(function() {
    'use strict';
    
    /**
     * Inicializa la funcionalidad del menú móvil
     */
    function initMobileMenu() {
        const body = document.body;
        const menuToggle = document.querySelector('.menu-toggle');
        const mobileMenu = document.querySelector('#mobile-menu');
        const menuIcon = menuToggle ? menuToggle.querySelector('i') : null;
        
        if (!menuToggle || !mobileMenu || !menuIcon) return;
        
        // Abrir/cerrar el menú
        menuToggle.addEventListener('click', function() {
            const expanded = this.getAttribute('aria-expanded') === 'true' || false;
            this.setAttribute('aria-expanded', !expanded);
            
            // Cambiar el icono según el estado del menú
            if (!expanded) {
                menuIcon.className = 'bi bi-x-lg text-subtitulo text-vermelho aspect-square';
                // Aplicar transformación para deslizar el menú hacia la derecha
                mobileMenu.style.transform = 'translateX(100%)';
                body.classList.add('overflow-hidden'); // Evitar scroll mientras el menú está abierto
                
                // Asegurarse de que la pantalla principal esté activa al abrir el menú
                resetMenuScreens();
            } else {
                closeMenu();
            }
        });
        
        // Cerrar el menú cuando se presiona la tecla Escape
        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape' && menuToggle.getAttribute('aria-expanded') === 'true') {
                closeMenu();
            }
        });
        
        // Función para cerrar el menú
        function closeMenu() {
            menuToggle.setAttribute('aria-expanded', 'false');
            menuIcon.className = 'bi bi-justify-left text-subtitulo text-vermelho aspect-square';
            
            // Esperar a que termine la transición de opacidad antes de ocultar completamente
            setTimeout(() => {
                // Restaurar la posición original del menú con transformación
                mobileMenu.style.transform = 'translateX(0)';
                body.classList.remove('overflow-hidden');
                
                // Resetear las pantallas del menú cuando se cierra
                setTimeout(() => {
                    resetMenuScreens();
                }, 300);
            }, 300);
        }
        
        // Inicializar la navegación por pantallas
        initScreenNavigation();
    }
    
    /**
     * Resetea todas las pantallas del menú a su estado inicial
     */
    function resetMenuScreens() {
        const screens = document.querySelectorAll('.menu-screen');
        screens.forEach(screen => {
            screen.classList.remove('active', 'previous', 'next');
            if (screen.id === 'main-menu-screen') {
                screen.classList.add('active');
                screen.style.display = 'block';
            } else {
                screen.classList.add('next');
                screen.style.display = 'none';
            }
        });
        
        // Forzar un reflow para asegurar que los cambios de clase se apliquen
        document.querySelector('#mobile-menu').offsetHeight;
    }
    
    /**
     * Inicializa la navegación por pantallas en el menú móvil
     */
    function initScreenNavigation() {
        // Botones para navegar a la siguiente pantalla
        const screenToggles = document.querySelectorAll('.menu-screen-toggle');
        
        screenToggles.forEach(toggle => {
            toggle.addEventListener('click', function() {
                const targetId = this.getAttribute('data-target');
                const targetScreen = document.getElementById(targetId);
                const currentScreen = document.querySelector('.menu-screen.active');
                
                if (!targetScreen || !currentScreen) return;
                
                // Preparar la pantalla de destino antes de la transición
                targetScreen.style.display = 'block';
                
                // Forzar un reflow para que el navegador procese los cambios
                targetScreen.offsetHeight;
                
                // Transición de pantallas
                currentScreen.classList.remove('active');
                currentScreen.classList.add('previous');
                
                // Asegurarse de que la pantalla de destino no tenga clases incorrectas
                targetScreen.classList.remove('next', 'previous');
                targetScreen.classList.add('active');
                
                // Aplicar un pequeño retraso antes de ocultar la pantalla anterior
                setTimeout(() => {
                    // Ocultar las demás pantallas que no están involucradas en la transición
                    document.querySelectorAll('.menu-screen:not(.active)').forEach(screen => {
                        if (screen !== targetScreen && screen !== currentScreen) {
                            screen.style.display = 'none';
                        }
                    });
                    
                    // Ocultar la pantalla anterior después de la transición
                    setTimeout(() => {
                        if (currentScreen && currentScreen !== targetScreen) {
                            currentScreen.style.display = 'none';
                            currentScreen.classList.remove('previous');
                            currentScreen.classList.add('next');
                        }
                    }, 300);
                }, 50);
            });
        });
        
        // Botones para volver a la pantalla anterior
        const backButtons = document.querySelectorAll('.menu-back');
        
        backButtons.forEach(button => {
            button.addEventListener('click', function() {
                const targetId = this.getAttribute('data-target');
                const targetScreen = document.getElementById(targetId);
                const currentScreen = document.querySelector('.menu-screen.active');
                
                if (!targetScreen || !currentScreen) return;
                
                // Preparar la pantalla de destino antes de la transición
                targetScreen.style.display = 'block';
                
                // Forzar un reflow para que el navegador procese los cambios
                targetScreen.offsetHeight;
                
                // Transición de pantallas (en reversa)
                currentScreen.classList.remove('active');
                currentScreen.classList.add('next');
                
                // Asegurarse de que la pantalla de destino no tenga clases incorrectas
                targetScreen.classList.remove('previous', 'next');
                targetScreen.classList.add('active');
                
                // Aplicar un pequeño retraso antes de ocultar la pantalla actual
                setTimeout(() => {
                    // Ocultar las demás pantallas que no están involucradas en la transición
                    document.querySelectorAll('.menu-screen:not(.active)').forEach(screen => {
                        if (screen !== targetScreen && screen !== currentScreen) {
                            screen.style.display = 'none';
                        }
                    });
                    
                    // Ocultar la pantalla actual después de la transición
                    setTimeout(() => {
                        if (currentScreen && currentScreen !== targetScreen) {
                            currentScreen.style.display = 'none';
                            currentScreen.classList.remove('next');
                            currentScreen.classList.add('previous');
                        }
                    }, 300);
                }, 50);
            });
        });
    }
    
    // Inicializar cuando el DOM esté listo
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initMobileMenu);
    } else {
        initMobileMenu();
    }
})();
